import { createSlice } from "@reduxjs/toolkit";
import {
  getMyNotifications,
  getUnreadCount,
  getNotificationStats,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  deleteAllNotifications,
  adminDeleteNotification,
} from "./thunk";

const initialState = {
  notifications: [],
  unreadCount: 0,
  stats: null,
  loading: false,
  error: null,
  successMessage: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    clearNotificationMessage: (state) => {
      state.successMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔹 GET NOTIFICATIONS
      .addCase(getMyNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
      })
      .addCase(getMyNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔹 UNREAD COUNT
      .addCase(getUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload.data;
      })

      // 🔹 STATS
      .addCase(getNotificationStats.fulfilled, (state, action) => {
        state.stats = action.payload.data;
      })

      // 🔹 MARK AS READ
      .addCase(markAsRead.fulfilled, (state, action) => {
        state.successMessage = "Notification marked as read";

        const updatedNotification = action.payload;
        const updatedId = updatedNotification?.id;

        state.notifications = state.notifications.map((notification) =>
          notification.id?.toString() === updatedId?.toString()
            ? { ...notification, isRead: true }
            : notification,
        );
      })

      // 🔹 MARK ALL AS READ
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.successMessage = "All notifications marked as read";
      })

      // 🔹 DELETE NOTIFICATION
      .addCase(deleteNotification.fulfilled, (state) => {
        state.successMessage = "Notification deleted successfully";
      })

      // 🔹 DELETE ALL
      .addCase(deleteAllNotifications.fulfilled, (state) => {
        state.notifications = [];
        state.successMessage = "All notifications deleted successfully";
      })

      // 🔹 ADMIN DELETE
      .addCase(adminDeleteNotification.fulfilled, (state) => {
        state.successMessage = "Notification deleted by admin";
      })

      // 🔹 COMMON ERROR HANDLER
      .addMatcher(
        (action) =>
          action.type.startsWith("notification/") &&
          action.type.endsWith("/rejected"),
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearNotificationMessage } = notificationSlice.actions;
export default notificationSlice.reducer;
